import BaseView from './base';

export default class MatrixFlipRowView extends BaseView {
    constructor(matrix) {
        super(matrix, matrix.rows, matrix.columns);
    }

    set(rowIndex, columnIndex, value) {
        this.matrix.set(this.rows - rowIndex - 1, columnIndex, value);
        return this;
    }

    get(rowIndex, columnIndex) {
        return this.matrix.get(this.rows - rowIndex - 1, columnIndex);
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/ml-kernel/~/ml-matrix/src/views/flipRow.js
// module id = 166
// module chunks = 0